exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal__SelectVehicleCreditorCompany-module___kBBib {\n  background-color: #0000001d;\n}\n\n.vehicleCreditorField__SelectVehicleCreditorCompany-module___Y4-C_ {\n  width: 100%;\n}\n\n.email__SelectVehicleCreditorCompany-module___fSCJF {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 177px;\n}\n.email__SelectVehicleCreditorCompany-module___fSCJF:hover {\n  white-space: wrap;\n  width: auto;\n}\n\n\n", ""]);

// Exports
exports.locals = {
	"modal": "modal__SelectVehicleCreditorCompany-module___kBBib",
	"vehicleCreditorField": "vehicleCreditorField__SelectVehicleCreditorCompany-module___Y4-C_",
	"email": "email__SelectVehicleCreditorCompany-module___fSCJF"
};